import React, { useState }  from 'react'
import { Accordion } from '../../02-Molecules/Accordion/Accordion'
import { Modal }     from '../../02-Molecules/Modal/Modal'

export const Faqs = ({ faqs }) => {
  const [modalShow, modalShowSet] = useState(false)

  /**
   * Handle the modal open / close action
   */
  const handleFaqModalShowHide = () => modalShowSet(!modalShow)

  return (
    <>
      <button className="o-footer__faq-btn" onClick={handleFaqModalShowHide}> FAQs</button>

      <Modal modalShow={modalShow} handleModalShow={handleFaqModalShowHide}>
        <Accordion faqs={faqs} />
      </Modal>
    </>

  )
}
